var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.wrapComponent,
    { tag: "component", class: _vm.column.class },
    [
      _vm.hasActionFn
        ? [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-link min-w-auto font-small text-decoration-none z-depth-0 text-btn-link m-0 p-0",
                attrs: {
                  "data-toggle": "tooltip-city",
                  type: "button",
                  title: _vm.$t(`${_vm.actionTitle}`),
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onActionFn.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n\t\t\t" + _vm._s(_vm.columnValue) + "\n\t\t")]
            ),
          ]
        : [_c("span", { domProps: { innerHTML: _vm._s(_vm.columnValue) } })],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }